import { MenuItem } from "@material-ui/core";
import React from "react";
import { useAppContext } from "./../../context/AppCtxProvider";
import { useScrollContext } from "./../../context/ScrollContextProvider";
import { stringTemplate } from "./../../tplutils/utils";
import KPIDetailsMenuContainer from "./../../viewcomponents/KPIDetailsContent/KPIDetailsMenuContainer";
import KPIDetailsMenuList from "./../../viewcomponents/KPIDetailsContent/KPIDetailsMenuList";
export interface PageInternalLink {
  title: string;
  anchor: string;
}
export interface IPageContentMenu {
  items: PageInternalLink[];
}
const PageContentMenu = (props: { componentData: IPageContentMenu }) => {
  const { items } = props.componentData;
  const ctx = useAppContext();
  const [clickedAnchor, setClickedAnchor] = React.useState("");
  const [clickedAnchorSetMs, setClickedAnchorMs] = React.useState(0);
  const activeElement = useScrollContext((state) => state.activeScrollElement);
  React.useEffect(() => {
    if (clickedAnchorSetMs < Date.now() - 1000) {
      setClickedAnchor("");
    }
  }, [activeElement]);
  const scrollTo = useScrollContext((state) => state.scrollTo);
  const hasActiveKey = (s: string) =>
    activeElement ? activeElement.key === s : false;
  return (
    <KPIDetailsMenuContainer>
      <KPIDetailsMenuList>
        {items.map((item, i) => {
          const anchor = item.anchor || "";
          return (
            <MenuItem
              style={{
                fontSize: "1.6em",
                paddingLeft: "0px",
                paddingRight: "0px",
                textAlign: ctx.rtl ? "right" : "left",
                overflow: "visible",
              }}
              key={item.title}
              selected={
                clickedAnchor ? anchor === clickedAnchor : hasActiveKey(anchor)
              }
              onClick={() => {
                scrollTo(anchor);
                setClickedAnchorMs(Date.now());
                setClickedAnchor(anchor);
              }}
            >
              {stringTemplate(item.title, { ctx, item })}
            </MenuItem>
          );
        })}
      </KPIDetailsMenuList>
    </KPIDetailsMenuContainer>
  );
};
export default PageContentMenu;
